import type { Contract } from '@definitions/types/symfonyTypes'

/** Returns true when at least one of the contract's affiliations matches the given theme key. */
export function isContractForTheme(
  contract: Contract,
  themeKey: string
): boolean {
  return (contract.affiliations?.edges ?? []).some(
    (edge) => edge?.node?.name.toLowerCase() === themeKey
  )
}
